// Project assemblies is a read-only lookup; create/edit happens from inspections.
import React from "react";

const ProjectAssembliesIndex = React.lazy(() => import("./index"));

export default [{ path: "/project/:project_id/assemblies", component: ProjectAssembliesIndex, name: "ProjectAssemblies" }];
